import React, { FC } from 'react';
import { Box, Grid } from '@material-ui/core';
import { PriceDisplayType } from '../../../../../../../../common/enum/PriceDisplayType';
import summaryLabelStyles from '../summaryLabel/SummaryLabelStyles';
import SummaryLabelTitle from '../summaryLabel/SummaryLabelTitle';
import PriceValue from '../summaryContent/summaryPrices/priceValue/PriceValue';
import IndicativeNumber from '../../../../../../gqlCommon/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../../customise/react/navigation/useScrollToSection';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';

export interface ISummaryLabelWithPrice {
  price: number;
  currency: string;
  loading?: boolean;
  isComplexModel?: boolean;
  priceType: PriceDisplayType;
  testId?: string;
  label: JSX.Element | string;
  indicativeNumber?: string;
}

const SummaryLabelWithPrice: FC<ISummaryLabelWithPrice> = ({
  currency,
  price,
  loading,
  isComplexModel,
  priceType,
  testId,
  label,
  indicativeNumber,
}) => {
  const styles = summaryLabelStyles();
  const { scrollToDisclaimer } = useScrollToSection();

  const renderLabel = () => {
    return (
      <Box display="flex" data-test={`summary:label:${testId}`} component="span">
        {label}
        {indicativeNumber && (
          <IndicativeNumber
            dataTest={'indicative'}
            onClick={scrollToDisclaimer}
            displayNumber={<Translation id={indicativeNumber} />}
          />
        )}
      </Box>
    );
  };

  return (
    <Grid container={true} justifyContent={'space-between'} spacing={3} className={styles.lineContainer}>
      <SummaryLabelTitle label={renderLabel()} boldLabel={isComplexModel} colSm={8} colXs={6} />
      <PriceValue
        loading={loading}
        price={price}
        priceType={priceType}
        currency={currency}
        boldPrice={true}
        decimals={0}
        testId={testId}
      />
    </Grid>
  );
};

export default SummaryLabelWithPrice;
